function themePickerSupported () {
  return window && window.matchMedia && window.matchMedia('(prefers-color-scheme)').matches
}

export default {
  auto: {
    name: 'Auto Light/Dark',
    statusBar: () => {
      const light = 'light'
      if (!themePickerSupported()) return light
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        return 'dark'
      } else {
        return light
      }
    },
    isSupported: () => {
      // Only show if it's supported by the browser
      return themePickerSupported()
    }
  },
  light: {
    name: 'Light',
    statusBar: 'light'
  },
  dark: {
    name: 'Dark',
    statusBar: 'dark'
  },
  black: {
    name: 'OLED black',
    statusBar: 'dark'
  }
}
